export default __webpack_public_path__ + "static/media/6.6d0c5938.jpg";